import React from 'react';

const PeakGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <path
                fill="#F6682F"
                fillRule="nonzero"
                d="M94.835 68.22L81.358 81.725 57.954 58.272 31.988 84.289c.095.44.193.882.302 1.318 4.56 17.789 20.672 30.94 39.848 30.94 11.862 0 22.545-5.04 30.052-13.086a41.152 41.152 0 0 0 9.833-18.018L94.835 68.22z"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M90.588 38.476c13.454 6.776 22.688 20.734 22.688 36.852 0 22.764-18.42 41.218-41.138 41.218-22.719 0-41.136-18.454-41.136-41.218 0-12.435 5.495-23.584 14.184-31.14"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M32.419 83.856L57.952 58.27l43.976 44.063m-19.86-21.32L94.835 68.22l17.023 17.056"
            />
            <path
                fill="#D2D6DF"
                fillRule="nonzero"
                d="M57.954 41.214h21.277V27H57.954z"
            />
            <path
                stroke="#363A43"
                strokeWidth={3}
                d="M57.953 58.271V27.002m32.626 75.33c-5.246 3.61-11.597 5.686-18.441 5.686-14.555 0-27.007-9.552-31.207-22.741"
            />
            <path
                stroke="#363A43"
                strokeWidth={2.563}
                d="M57.953 65.378v2.842m0 2.843v2.844m0 2.842v2.843"
            />
        </g>
    </svg>
);

PeakGraphicSvg.displayName = 'PeakGraphicSvg';
export default PeakGraphicSvg;
